const HackathonSessionHeader = () => (
  <div className="m-auto mt-3 text-center">
    <h2 className="mb-4 text-4xl font-bold text-gray-900 md:text-5xl">
      IBM AI Hackathon
    </h2>
    <p className="prose mx-auto max-w-3xl text-pretty text-left text-xl leading-relaxed text-gray-700">
      Build the future of Michigan innovation. Join us for a day of coding,
      collaboration, and creating AI solutions that keep opportunities here at
      home—by Michiganders, for Michigan.
    </p>
  </div>
)

export default HackathonSessionHeader
